var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Auth"}},[_c('div',{staticClass:"w-full absolute flex justify-center items-center sm:top-0 z-30"},[_c('AppModal')],1),_c('router-view'),_c('NotificationsContainer'),_c('AlertsContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }